
export default function ExpertiseSection() {
  const expertiseAreas = [
    {
      icon: 'ri-home-smile-line',
      title: 'Smart Infrastructure',
      items: [
        'AI Smart Homes • Sustainable Cities • Affordable Housing',
        'Hospitals • Research & Health Campuses',
        'Warehouses • Cold Storage • Logistics Hubs',
        'Ports • Maritime Facilities • Free Trade Zones',
        'Airports • Rail • Transit Hubs'
      ]
    },
    {
      icon: 'ri-leaf-line',
      title: 'Green Solutions',
      items: [
        'Green Power — Solar, Wind, Microgrids',
        'Education & Community Development',
        'Commercial & Industrial Complexes',
        'Defense & Emergency Infrastructure',
        'Smart Farming & Agro-Logistics Systems'
      ]
    }
  ];

  return (
    <section id="expertise" className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 mb-4">
            Global Expertise
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Comprehensive construction and development solutions across multiple sectors and industries worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="bg-slate-800/50 border border-yellow-400/20 rounded-2xl p-8 hover:border-yellow-400/40 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center mr-4">
                  <i className={`${area.icon} text-xl text-slate-900`}></i>
                </div>
                <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600">
                  {area.title}
                </h3>
              </div>
              <ul className="space-y-3">
                {area.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-slate-300 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Global Reach */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-slate-800/50 to-slate-700/50 border border-yellow-400/20 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-4">Global Reach</h3>
            <p className="text-slate-300 mb-6 max-w-4xl mx-auto">
              From North America to emerging markets worldwide, we deliver world-class infrastructure solutions 
              that meet local needs while maintaining international standards of excellence.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {['North America', 'Europe', 'Asia Pacific', 'Middle East', 'Africa', 'Latin America'].map((region) => (
                <span key={region} className="px-4 py-2 bg-yellow-400/10 border border-yellow-400/30 rounded-full text-yellow-400 text-sm">
                  {region}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
